import axios from "axios";

const API_ROOT = window.__BACKEND_URL__ + "/api";


const GROUPS_V1 = API_ROOT + "/groups/";

const MONITORED_ITEMS_ENDPOINT = API_ROOT + "/monitored_items/";

const MONITORED_ITEMS_DETAIL = MONITORED_ITEMS_ENDPOINT + "{id}/";

const GROUPS_V2 = API_ROOT + "/groups_v2/";

const GROUPS_V2_DETAIL = GROUPS_V2 + "{id}/";

const GROUP_ACTIONS = {
  addGroupToMonitorItem: GROUPS_V2_DETAIL + "setGroupToMonitoredSearchHistory/",
  removeGroupFromMonitoredSearchHistory:
    GROUPS_V2_DETAIL + "removeGroupFromMonitoredSearchHistory/",
};

export const fetchGroups = async (monitoredItemId) => {
  return await axios.get(GROUPS_V2, {
    params: {
      searchHistoryId: monitoredItemId,
    },
  });
};

export const addGroupToMonitorItem = async (monitorItemId, groupId) => {
  return await axios.post(
    GROUP_ACTIONS.addGroupToMonitorItem.replace("{id}", groupId),
    {
      monitored_item_id: monitorItemId,
    }
  );
};

export const fetchMonitoredItem = async (montioterItemId) => {
  return await axios.get(
    MONITORED_ITEMS_DETAIL.replace("{id}", montioterItemId)
  );
};

export const removeGroupFromMonitoredSearchHistory = async (monitorItemId, groupId) => {
  return await axios.post(
    GROUP_ACTIONS.removeGroupFromMonitoredSearchHistory.replace("{id}", groupId),
    {
      monitored_item_id: monitorItemId,
    }
  );
};


export const addGroup = async (groupName) => {
    return await axios.post(
        GROUPS_V1,
        {name: groupName}
    )
}
